module.exports = __webpack_public_path__ + "img/0Q3A2626_L_Foamcore_MockedUp.ac4f7b61.jpg";